import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const Hamburguer = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Menu",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 40 40"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path d="M36.667 8.333V10H3.334V8.333zm-33.333 12.5h33.333v-1.667H3.334zm33.333 10.833H3.334V30h33.333z"></path>
    </svg>
  );
};


